const allRoles = (entry) => ({
    superadmin: entry,
    admin: entry,
    hr_department: entry,
    staff: entry,
    private_person: entry,
});

const byRoleGroup = ({ hr, staff }) => ({
    superadmin: hr,
    admin: hr,
    hr_department: hr,
    staff,
    private_person: staff,
});

const PAGE_HINTS = [
    {
        match: (path) => path === "/",
        byRole: byRoleGroup({
            hr: {
                text:
                    "Это «Моя компания» — главный экран по вашей компании. " +
                    "Здесь видны ключевые показатели и быстрые действия. Чем помочь?",
                actions: [
                    { label: "К сотрудникам", route: "/staff" },
                    { label: "К группам", route: "/groups" },
                    { label: "Открыть мониторинг", route: "/analytics/dashboard" },
                ],
            },
            staff: {
                text:
                    "Это главная страница. Ваши результаты и развивающие программы — " +
                    "в личном кабинете.",
                actions: [
                    { label: "Личный кабинет", route: "/personal" },
                    { label: "Моё развитие", route: "/my-development" },
                ],
            },
        }),
    },
    {
        match: (path) => path === "/staff" || path.startsWith("/staff/"),
        byRole: byRoleGroup({
            hr: {
                text:
                    "Это раздел «Сотрудники». Здесь можно добавить сотрудника, изменить данные " +
                    "или загрузить список через Excel. Подсказать как?",
                actions: [
                    { label: "HR Администраторы", route: "/hr/admins" },
                ],
            },
            staff: {
                text:
                    "Этот раздел доступен HR/руководителю. Ваши данные — в разделе «Профиль».",
                actions: [{ label: "Профиль", route: "/profile" }],
            },
        }),
    },
    {
        match: (path) => path === "/groups" || path.startsWith("/group"),
        byRole: byRoleGroup({
            hr: {
                text:
                    "Это «Группы» — здесь формируются команды для тестирования. " +
                    "Создайте группу, добавьте сотрудников и назначьте тест.",
                actions: [{ label: "К сотрудникам", route: "/staff" }],
            },
            staff: {
                text:
                    "Группы формирует HR/руководитель. Назначенные вам тесты появятся " +
                    "в разделе «Моё развитие».",
                actions: [{ label: "Моё развитие", route: "/my-development" }],
            },
        }),
    },
    {
        match: (path) => path === "/hr/admins",
        byRole: {
            superadmin: {
                text:
                    "Раздел «HR Администраторы». Здесь создаются под-HR и им назначаются группы.",
                actions: [{ label: "К группам", route: "/groups" }],
            },
            admin: {
                text:
                    "Раздел «HR Администраторы». Здесь создаются под-HR и им назначаются группы.",
                actions: [{ label: "К группам", route: "/groups" }],
            },
            hr_department: {
                text:
                    "Создание HR Администраторов доступно только главному HR/руководителю. " +
                    "Если нужен ещё один под-HR — напишите ему.",
                actions: [],
            },
            staff: {
                text: "Раздел доступен HR/руководителю.",
                actions: [],
            },
            private_person: {
                text: "Раздел доступен HR/руководителю.",
                actions: [],
            },
        },
    },
    {
        match: (path) => path.startsWith("/analytics/dashboard"),
        byRole: byRoleGroup({
            hr: {
                text:
                    "Это «Мониторинг» — дашборд по ключевым показателям. " +
                    "Подсказать, как смотреть отчёты или выгружать данные?",
                actions: [{ label: "К отчётам", route: "/analytics/reports" }],
            },
            staff: {
                text: "Аналитика доступна HR/руководителю.",
                actions: [{ label: "Моё развитие", route: "/my-development" }],
            },
        }),
    },
    {
        match: (path) => path.startsWith("/analytics/reports") || path.startsWith("/analytics/"),
        byRole: byRoleGroup({
            hr: {
                text:
                    "Это «Отчёты» — можно собирать отчёты по группе, компании или тесту и " +
                    "выгружать их.",
                actions: [{ label: "Мониторинг", route: "/analytics/dashboard" }],
            },
            staff: {
                text:
                    "Раздел доступен HR/руководителю. Свои результаты вы найдёте в «Моё развитие».",
                actions: [{ label: "Моё развитие", route: "/my-development" }],
            },
        }),
    },
    {
        match: (path) => path === "/catalog",
        byRole: byRoleGroup({
            hr: {
                text:
                    "Это «Каталог решений» — здесь можно выбрать тесты, курсы и оформить заказ. " +
                    "Заказы потом доступны в разделе «Заказы».",
                actions: [{ label: "Мои заказы", route: "/my-orders" }],
            },
            staff: {
                text:
                    "Заказ продуктов делает HR/руководитель. Если нужен какой-то тест или курс — " +
                    "напишите ему.",
                actions: [],
            },
        }),
    },
    {
        match: (path) => path === "/my-orders" || path.startsWith("/orders"),
        byRole: byRoleGroup({
            hr: {
                text:
                    "Это «Заказы». Здесь видны статусы и можно перейти к оформлению нового заказа " +
                    "через каталог.",
                actions: [{ label: "Открыть каталог", route: "/catalog" }],
            },
            staff: {
                text: "Раздел заказов доступен HR/руководителю.",
                actions: [],
            },
        }),
    },
    {
        match: (path) => path === "/personal",
        byRole: allRoles({
            text:
                "Это «Личный кабинет». Здесь видны ваши результаты ЭИ и связанные программы.",
            actions: [
                { label: "Моё развитие", route: "/my-development" },
                { label: "Дневник эмоций", route: "/diary" },
            ],
        }),
    },
    {
        match: (path) => path === "/my-development",
        byRole: allRoles({
            text:
                "Это «Моё развитие» — назначенные тесты, тренажёры и развивающие программы. " +
                "Если раздел пустой, программу должен назначить HR/руководитель.",
            actions: [
                { label: "Навигатор эмоций", route: "/mood/tracker" },
                { label: "Дневник эмоций", route: "/diary" },
            ],
        }),
    },
    {
        match: (path) => path === "/diary" || path.startsWith("/diary"),
        byRole: allRoles({
            text:
                "Это «Дневник эмоций». Фиксируйте состояния, отслеживайте динамику и " +
                "смотрите аналитику.",
            actions: [{ label: "Аналитика дневника", route: "/diary/analytics" }],
        }),
    },
    {
        match: (path) => path === "/mood/tracker",
        byRole: allRoles({
            text:
                "Это «Навигатор эмоций» — фиксируйте настроение и получайте рекомендации, " +
                "что с этим делать.",
            actions: [{ label: "Библиотека эмоций", route: "/library/list" }],
        }),
    },
    {
        match: (path) => path === "/library/list" || path.startsWith("/library/"),
        byRole: allRoles({
            text:
                "Это «Библиотека эмоций» — 27 эмоций с описанием и упражнениями. " +
                "Откройте любую эмоцию для подробностей.",
            actions: [{ label: "Навигатор эмоций", route: "/mood/tracker" }],
        }),
    },
    {
        match: (path) => path === "/subscription" || path.startsWith("/subscription"),
        byRole: {
            superadmin: {
                text:
                    "Это «Подписка». Здесь видно текущий тариф и можно продлить подписку.",
                actions: [],
            },
            admin: {
                text:
                    "Это «Подписка». Здесь видно текущий тариф и можно продлить подписку.",
                actions: [],
            },
            hr_department: {
                text:
                    "Управление подпиской делает главный HR/руководитель.",
                actions: [],
            },
            staff: {
                text: "Раздел доступен HR/руководителю.",
                actions: [],
            },
            private_person: {
                text:
                    "Здесь можно посмотреть и продлить подписку.",
                actions: [],
            },
        },
    },
    {
        match: (path) => path === "/faq" || path.startsWith("/faq"),
        byRole: allRoles({
            text:
                "Это «Помощь с ЛК» — справка по личному кабинету. Если нужного раздела " +
                "не нашли, спросите меня в чате.",
            actions: [],
        }),
    },
    {
        match: (path) => path === "/profile",
        byRole: allRoles({
            text: "Это «Профиль». Здесь можно поменять личные данные и пароль.",
            actions: [],
        }),
    },
    {
        match: (path) => path === "/rating" || path === "/detailed",
        byRole: byRoleGroup({
            hr: {
                purpose:
                    "Раздел «Оценка» нужен, чтобы управлять тестированиями команды: " +
                    "видеть статусы, выдавать и напоминать о прохождении, скачивать отчёты и настраивать видимость для сотрудников.",
                text:
                    "Здесь видны прохождения тестирований, статусы и отчёты по сотрудникам и группам.",
                whatCanDo:
                    "На этой странице вы можете:\n" +
                    "• выдать тест сотруднику или группе;\n" +
                    "• напомнить о незавершённом прохождении;\n" +
                    "• скачать отчёт после завершения;\n" +
                    "• открыть сводную таблицу по всем прохождениям;\n" +
                    "• настроить, видит ли сотрудник свой отчёт.",
                actions: [
                    { label: "Сводная таблица", route: "/detailed" },
                    { label: "Спецотчёты", route: "/analytics/reports" },
                ],
            },
            staff: {
                text: "Раздел доступен HR/руководителю.",
                actions: [],
            },
        }),
    },
    {
        match: (path) => path === "/instruments",
        byRole: allRoles({
            text:
                "Это «Ежедневные помощники» — короткие инструменты на каждый день для " +
                "поддержания состояния.",
            actions: [],
        }),
    },
    {
        match: (path) => path === "/courses",
        byRole: allRoles({
            text:
                "Это «Развитие» — доступные курсы. Открывайте карточку курса, чтобы начать.",
            actions: [{ label: "Моё развитие", route: "/my-development" }],
        }),
    },
];

const DEFAULT_HINT = {
    text: "Я ИИ-помощник Прохор. Подскажу по навигации в кабинете — спросите, что нужно.",
    actions: [{ label: "Помощь с ЛК", route: "/faq" }],
};

export const getPageHint = (path, role) => {
    const normalizedPath = (path || "/").split("?")[0];

    const rule = PAGE_HINTS.find((item) => item.match(normalizedPath));
    if (!rule) return { ...DEFAULT_HINT, purpose: DEFAULT_HINT.text };

    const hint = rule.byRole[role];
    if (!hint) return { ...DEFAULT_HINT, purpose: DEFAULT_HINT.text };

    return {
        ...hint,
        purpose: hint.purpose || hint.text,
        whatCanDo: hint.whatCanDo || hint.text,
    };
};

export const hasPageHint = (path) => {
    const normalizedPath = (path || "/").split("?")[0];
    return PAGE_HINTS.some((item) => item.match(normalizedPath));
};
